module.exports = __webpack_public_path__ + "img/01 Animation 2-squashed.c288e332.jpg";